import { useSelector } from 'react-redux'
import { Button } from '../../../../../common/html/button'
import { expiryDate } from '../../../../../dashboard/components/currentPlan/helper'
import { getDataCurrentPlan } from '../../../../../dashboard/components/currentPlan/store/slice'
import classes from '../../../../index.module.scss'
import { USER_TYPE_STANDARD } from '../constants'

const styleButtonUpgrade = {
  border: 'none',
  backgroundColor: '#FFCD60',
  width: 230,
  height: 38,
  fontSize: 14,
  borderRadius: '4px',
  fontWeight: 600,
}

const UpgradeBtn = ({
  handleUpgrade,
  canUpgradeToStandard,
  canUpgradeToPremium,
  setIsDefaultSelectPremium,
  setOpenPopupExistedSubscription,
}) => {
  const dataCurrentPlan = useSelector(getDataCurrentPlan)
  const handleUpgradePremium = () => {
    if (
      USER_TYPE_STANDARD === dataCurrentPlan?.dataPackageName &&
      expiryDate(dataCurrentPlan?.endDate) > 0
    ) {
      setOpenPopupExistedSubscription(true)
      return
    }
    setIsDefaultSelectPremium(true)
    handleUpgrade()
  }

  return (
    <div className={classes.upgrade}>
      <div
        className={['w100 dFlex justifyContentCenter', classes.upgradeBtn].join(
          ' ',
        )}
      >
        {canUpgradeToStandard && (
          <Button
            label="userManagement.upgradeViewPlan.UPGRADE_TO_STANDARD"
            className="cursorPointer"
            style={styleButtonUpgrade}
            action={handleUpgrade}
            isI18n
          />
        )}
        {canUpgradeToPremium && (
          <Button
            label="userManagement.upgradeViewPlan.UPGRADE_TO_PREMIUM"
            className="cursorPointer"
            style={styleButtonUpgrade}
            action={handleUpgradePremium}
            isI18n
          />
        )}
      </div>
    </div>
  )
}

export default UpgradeBtn
